import axios from '@/clientAPI.ts'
import axiosV3 from '@/clientAPIV3'
import {Message} from '@/features/common/types'
import {AxiosResponse} from 'axios'
import * as types from '../types'
import {SubscriptionStatusesE} from '@/features/chat/chat.model'

export const RECURRING_GIFT_API = {
    getSubscriptionsAmounts: async (
        is_edit: number //1 | 0
    ): Promise<types.DonationType[]> => {
        const {data} = await axios.get('/subscriptions/packages', {params: {is_edit}})
        return data
    }
}

export const subscribeToHostV3 = async (
    payload: types.SubscribeToHostRequestV3
): Promise<AxiosResponse<types.CreditCardUrl | Message>> => {
    const {hostID, subscriptionId, campaignId, userDiscountId} = payload

    const response = await axiosV3.post(`subscriptions/creators/${hostID}`, {
        subscriptionPackageId: +subscriptionId,
        campaignId,
        userDiscountId
    })

    return response.data
}

export const unSubscribeFromHostV3 = async (subscriptionId: string): Promise<Message> => {
    const {data} = await axiosV3.delete(`subscriptions/${subscriptionId}`)
    return data
}

export const getSubscribedGuestsV3 = async (status: string): Promise<types.DonationV3[]> => {
    const response = await axiosV3.get('/subscriptions/followers', {
        params: {status}
    })

    return response.data
}

export const getSubscribedHostsV3 = async (status?: SubscriptionStatusesE): Promise<types.DonationV3[]> => {
    const response = await axiosV3.get('/subscriptions/creators', {
        params: {status}
    })

    return response.data
}
